import { render, staticRenderFns } from "./skuWaitToDone.vue?vue&type=template&id=637f3768&scoped=true&"
import script from "./skuWaitToDone.vue?vue&type=script&lang=js&"
export * from "./skuWaitToDone.vue?vue&type=script&lang=js&"
import style0 from "./skuWaitToDone.vue?vue&type=style&index=0&id=637f3768&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "637f3768",
  null
  
)

export default component.exports